import angular from "angular"

var SERVICE_NAME = "permissionService"

angular.module("appModule").service(SERVICE_NAME, [
  "store",
  function(store) {
    var self = this

    self.descargarReportes = function() {
      var user = store.get("user")
      return user.rol !== "RESPONSABLE" && user.rol_id != "0"
    }

    self.mantenedorUsuarios = function() {
      var user = store.get("user")
      return user.rol === "ADMINISTRADOR" && user.rol_id != "0"
    }

    self.mantenedorAtenciones = function() {
      var user = store.get("user")
      return user.rol === "ADMINISTRADOR" && user.rol_id != "0"
    }

    self.eliminarAtenciones = function() {
      var user = store.get("user")
      return user.rol !== "RESPONSABLE" && user.rol_id != "0"
    }

    self.eliminarAlertas = function() {
      var user = store.get("user")
      return user.rol !== "RESPONSABLE" && user.rol_id != "0"
    }

    self.eliminarComentarios = function() {
      var user = store.get("user")
      return user.rol !== "RESPONSABLE" && user.rol_id != "0"
    }

    self.editarSoloAtencionesMasivas = function() {
      var user = store.get("user") || {}
      return user.hasOwnProperty("rol") && user.rol === "EDITOR ATENCIONES MASIVAS"
    }

    self.hasSpecificRole = function(roleName) {
      if (roleName) {
        var user = store.get("user")
        return user.hasOwnProperty("rol") && user.rol === roleName
      } else {
        return false
      }
    }

    return {
      descargarReportes: self.descargarReportes,
      mantenedorUsuarios: self.mantenedorUsuarios,
      mantenedorAtenciones: self.mantenedorAtenciones,
      eliminarAtenciones: self.eliminarAtenciones,
      eliminarAlertas: self.eliminarAlertas,
      eliminarComentarios: self.eliminarComentarios,
      editarSoloAtencionesMasivas: self.editarSoloAtencionesMasivas,
      hasSpecificRole: self.hasSpecificRole
    }
  }
])

export default SERVICE_NAME
